import React from "react";
import { useTranslation } from "react-i18next";
import "../../../styles/ImageEnhancementTool.css";

const ImageEnhancementBody = (props) => {
  const {
    activeEnhancements,
    sharpnessValue,
    setSharpnessValue,
    gaussianValue,
    setGaussianValue,
    medianValue,
    setMedianValue,
    edgeEnhanceValue,
    setEdgeEnhanceValue,
  } = props;

  const { t } = useTranslation();

  return (
    <div className="enhancement-modal-body">
      <div className="ms-Grid" dir="ltr">
        {/* Sharpening */}
        <div className="ms-Grid-row" style={{ marginTop: "10px", alignItems: "center" }}>
          <div className="ms-Grid-col ms-sm12 ms-md5 ms-lg5 ms-xl5">
            <label
              className={
                activeEnhancements.has("sharpening")
                  ? "control-label active"
                  : "control-label"
              }
            >
              {t("viewer.tools.ie-sharpening", "Sharpening")}
            </label>
          </div>
          <div className="ms-Grid-col ms-sm8 ms-md6 ms-lg6 ms-xl6">
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={sharpnessValue}
              onChange={(e) => setSharpnessValue(parseFloat(e.target.value))}
              className="slider"
            />
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md1 ms-lg1 ms-xl1">
            <span className="value-display">
              {(sharpnessValue * 100).toFixed(0)}%
            </span>
          </div>
        </div>

        {/* Gaussian Blur (De-noise) - 15×15 kernel, σ=5.0 */}
        <div className="ms-Grid-row" style={{ marginTop: "10px", alignItems: "center" }}>
          <div className="ms-Grid-col ms-sm12 ms-md5 ms-lg5 ms-xl5">
            <label
              className={
                activeEnhancements.has("gaussian")
                  ? "control-label active"
                  : "control-label"
              }
            >
              {t("viewer.tools.ie-gaussian", "Gaussian Blur (De-noise)")}
            </label>
          </div>
          <div className="ms-Grid-col ms-sm8 ms-md6 ms-lg6 ms-xl6">
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={gaussianValue}
              onChange={(e) => setGaussianValue(parseFloat(e.target.value))}
              className="slider"
            />
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md1 ms-lg1 ms-xl1">
            <span className="value-display">
              {(gaussianValue * 100).toFixed(0)}%
            </span>
          </div>
        </div>

        {/* Median Filter (Denoise) - 3×3 kernel, CPU-based */}
        <div className="ms-Grid-row" style={{ marginTop: "10px", alignItems: "center" }}>
          <div className="ms-Grid-col ms-sm12 ms-md5 ms-lg5 ms-xl5">
            <label
              className={
                activeEnhancements.has("median")
                  ? "control-label active"
                  : "control-label"
              }
            >
              {t("viewer.tools.ie-median", "Median Filter (Denoise)")}
            </label>
          </div>
          <div className="ms-Grid-col ms-sm8 ms-md6 ms-lg6 ms-xl6">
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={medianValue}
              onChange={(e) => setMedianValue(parseFloat(e.target.value))}
              className="slider"
            />
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md1 ms-lg1 ms-xl1">
            <span className="value-display">
              {(medianValue * 100).toFixed(0)}%
            </span>
          </div>
        </div>

        {/* Edge Enhancement - 3×3 Laplacian kernel */}
        <div className="ms-Grid-row" style={{ marginTop: "10px", alignItems: "center" }}>
          <div className="ms-Grid-col ms-sm12 ms-md5 ms-lg5 ms-xl5">
            <label
              className={
                activeEnhancements.has("edgeEnhance")
                  ? "control-label active"
                  : "control-label"
              }
            >
              {t("viewer.tools.ie-edge", "Edge Enhancement")}
            </label>
          </div>
          <div className="ms-Grid-col ms-sm8 ms-md6 ms-lg6 ms-xl6">
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={edgeEnhanceValue}
              onChange={(e) => setEdgeEnhanceValue(parseFloat(e.target.value))}
              className="slider"
            />
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md1 ms-lg1 ms-xl1">
            <span className="value-display">
              {(edgeEnhanceValue * 100).toFixed(0)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageEnhancementBody;
